import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="accordion"
export default class extends Controller {
  static targets = ["section"];

  connect() {
    // Optionally auto-expand the first section if data-auto-expand-first is present
    if (this.element.dataset.autoExpandFirst === "true") {
      this.expandSection(0);
    }
  }

  toggle(event) {
    const clickedSection = event.currentTarget.closest(
      '[data-accordion-target="section"]'
    );
    const sectionIndex = this.sectionTargets.indexOf(clickedSection);
    const isExpanded = clickedSection.dataset.expanded === "true";

    if (isExpanded) {
      // Collapse if already expanded
      this.collapseSection(sectionIndex);
    } else {
      // Close others then expand
      this.sectionTargets.forEach((_section, index) =>
        this.collapseSection(index)
      );
      this.expandSection(sectionIndex);
    }
  }

  expandSection(index) {
    const section = this.sectionTargets[index];
    if (!section) return;

    const content = section.querySelector("[data-accordion-content]");
    const icon = section.querySelector("[data-accordion-icon]");

    if (content) {
      content.classList.remove("hidden");
    }

    if (icon) {
      icon.style.transform = "rotate(180deg)";
    }

    // Update expanded state
    section.dataset.expanded = "true";
    const button = section.querySelector("[data-accordion-button]");
    if (button) button.setAttribute("aria-expanded", "true");
  }

  collapseSection(index) {
    const section = this.sectionTargets[index];
    if (!section) return;

    const content = section.querySelector("[data-accordion-content]");
    const icon = section.querySelector("[data-accordion-icon]");

    if (content) {
      content.classList.add("hidden");
    }

    if (icon) {
      icon.style.transform = "rotate(0deg)";
    }

    // Update expanded state
    section.dataset.expanded = "false";
    const button = section.querySelector("[data-accordion-button]");
    if (button) button.setAttribute("aria-expanded", "false");
  }
}
